export const ADD_LOADER = 'addLoader'
export const REMOVE_LOADER = 'removeLoader'
export const SET_CONFIG = 'setConfig'
